export default __webpack_public_path__ + "static/media/icon-cedula.9d4a8fdb.svg";